import React from 'react';
import HeroSection from '../components/sections/HeroSection';
import StatsSection from '../components/sections/StatsSection';
import TrustSection from '../components/sections/TrustSection';
import ServicesSection from '../components/sections/ServicesSection';
import AssessmentSection from '../components/sections/AssessmentSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import { Helmet } from 'react-helmet';
export default function Home() {
  return <main className="min-h-screen bg-white" data-id="element-535">
      <Helmet data-id="element-536">
        <title data-id="element-537">
          Medico-Legal Psychiatry – Expert Witness Psychiatric Services UK
        </title>
        <meta name="description" content="Independent medico-legal psychiatry led by Dr. Imtiaz Syed. Expert witness reports, trauma, capacity, ADHD, PTSD & forensic assessments UK-wide." data-id="element-538" />
        <meta name="keywords" content="Medico-Legal Psychiatry, Expert Witness Psychiatrist UK, Psychiatric Expert Witness Reports, Independent Psychiatric Reports UK, Forensic Psychiatric Assessments UK, Mental Capacity Assessments UK, ADHD & Autism Medico-Legal Assessments" data-id="element-539" />
        <script type="application/ld+json" data-id="element-540">
          {`
            {
              "@context": "https://schema.org",
              "@type": "MedicalBusiness",
              "name": "Medico-Legal Psychiatry",
              "url": "https://medicolegal-psychiatry.co.uk/",
              "logo": "https://uploadthingy.s3.us-west-1.amazonaws.com/hDXV1rDXM1m2ARqkQ9Hg8F/Medico_Favicon.png",
              "address": {
                "@type": "PostalAddress",
                "addressRegion": "Warwickshire",
                "addressCountry": "UK"
              },
              "email": "enquiries@medicolegal-psychiatry.co.uk",
              "telephone": "",
              "openingHoursSpecification": [
                {
                  "@type": "OpeningHoursSpecification",
                  "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
                  "opens": "09:00",
                  "closes": "17:00"
                },
                {
                  "@type": "OpeningHoursSpecification",
                  "dayOfWeek": "Saturday",
                  "opens": "09:00",
                  "closes": "13:00"
                }
              ],
              "medicalSpecialty": "Psychiatry",
              "description": "Independent medico-legal psychiatry led by Dr. Imtiaz Syed. Expert witness reports, trauma, capacity, ADHD, PTSD & forensic assessments UK-wide."
            }
          `}
        </script>
      </Helmet>
      <HeroSection data-id="element-541" />
      <StatsSection data-id="element-542" />
      <TrustSection data-id="element-543" />
      <ServicesSection data-id="element-544" />
      <AssessmentSection data-id="element-545" />
      <TestimonialsSection data-id="element-546" />
      <section className="py-8 bg-gray-50 border-t border-gray-200" data-id="element-547">
        <div className="container mx-auto px-4" data-id="element-548">
          <div className="flex items-center justify-center gap-3" data-id="element-549">
            <span className="text-slate text-sm" data-id="element-550">Website created by</span>
            <a href="https://bright-pixxel.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 transition-opacity hover:opacity-80" data-id="element-551">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/spdsZGPouzsb8mdDCE9yxi/Geometric_Logo_of_Bright_Pixxel_Studio.png" alt="Bright Pixxel Studio" className="h-8 w-auto" data-id="element-552" />
              <span className="font-semibold text-primary" data-id="element-553">
                Bright Pixxel Studio
              </span>
            </a>
          </div>
        </div>
      </section>
    </main>;
}